import { useEffect } from 'react';

const LoginScreen = ({ onLogin, loginError }) => {
    useEffect(() => {
        document.title = 'RMUTTO URL Shortener';
    }, []);

    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 p-4">
            <div className="text-center">
                <img
                    src="/rmutto-logo.png"
                    alt="ARIT RMUTTO Logo"
                    className="mx-auto mb-4 h-20 w-auto"
                />
                <h1 className="text-3xl font-bold text-slate-800 md:text-4xl">RMUTTO URL Shortener</h1>
                <p className="mt-2 text-slate-600">บริการย่อลิงก์และสร้าง QR Code สำหรับชาว มทร. ตะวันออก</p>
            </div>

            <div className="mt-8 w-full max-w-sm rounded-xl border border-slate-200 bg-white p-8 shadow-sm">
                <h2 className="text-center text-xl font-semibold text-slate-700">เข้าสู่ระบบ</h2>
                <p className="mt-2 text-center text-slate-500">
                    กรุณาเข้าสู่ระบบด้วยบัญชี Google
                    <br />
                    ของมหาวิทยาลัยฯ (@rmutto.ac.th)
                </p>

                {loginError && (
                    <div className="mt-4 rounded-lg border border-red-200 bg-red-50 p-3 text-center text-sm text-red-700">
                        {loginError}
                    </div>
                )}

                <button
                    onClick={onLogin}
                    className="mt-6 flex w-full items-center justify-center gap-3 rounded-lg bg-blue-600 px-4 py-3 font-semibold text-white shadow-sm transition-colors duration-300 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >
                    <svg className="h-6 w-6" viewBox="0 0 48 48">
                        <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z" />
                        <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z" />
                        <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z" />
                        <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.574l6.19,5.238C41.38,36.128,44,30.638,44,24C44,22.659,43.862,21.35,43.611,20.083z" />
                    </svg>
                    เข้าสู่ระบบด้วย Google
                </button>
            </div>
        </div>
    );
};

export default LoginScreen;
